import * as ng from 'angular';

interface ILogger {
    error(message: string, data?: any, title?: string): void;
    info(message: string, data?: any, title?: string): void;
    success(message: string, data?: any, title?: string): void;
    warning(message: string, data?: any, title?: string): void;
}

let LoggerFactory: Function = function($log: ng.ILogService): ILogger  {

        return new LoggerService($log);

    };

LoggerFactory.$inject = ['$log'];

class LoggerService implements ILogger {

    constructor(private $log: ng.ILogService, private _showToasts: Boolean = true ) {
        this.$log = $log;
        this._showToasts = _showToasts; 
    }

    public get showToasts(): Boolean {
        return this._showToasts; 
    }

    public set showToasts(val: Boolean) {
        this._showToasts = val;
    }

    public error(message: string, data: any, title: string): void {
        //toastr.error(message, title);
        this.$log.error('Error: ' + message, data);
    }

    public info(message: string, data: any, title: string): void {
        // toastr.info(message, title);
        this.$log.info('Info: ' + message, data);
    }

    public success(message: string, data: any, title: string): void {
        //toastr.success(message, title);
        this.$log.info('Success: ' + message, data);
    }

    public warning(message: string, data: any, title: string): void {
        //toastr.warning(message, title);
        this.$log.warn('Warning: ' + message, data);
    }

}

let Logger = {
    name: "logger",
    factory: LoggerFactory
};

export { Logger, ILogger }
export default Logger;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/core/logger.ts